import {
  LIST_DASHBOARD_DATA,
  LIST_DASHBOARD_DATA_LOADING,
  RESET_DASHBOARD_CACHE,
  LOGOUT,
} from "../../actions/types";

const initialState = {
  loading: false,
  data: [],
  /** Aggregates from instances-metrics `getStats` (preferred for overview charts). */
  getStats: null,
  /** Top-level `total` from instances-metrics response (e.g. row count). */
  metricsTotal: null,
  params: null,
  loaded: false,
};

export default function analyticsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LIST_DASHBOARD_DATA_LOADING:
      return {
        ...state,
        loading: !!payload,
      };
    case LIST_DASHBOARD_DATA: {
      let nextData = [];
      const p = payload?.data;
      if (Array.isArray(p)) {
        nextData = p;
      } else if (p != null && typeof p === "object" && Array.isArray(p.data)) {
        nextData = p.data;
      }
      const getStats =
        payload?.getStats != null && typeof payload.getStats === "object" ? payload.getStats : null;
      const metricsTotalRaw = payload?.metricsTotal;
      const metricsTotal =
        metricsTotalRaw != null && !Number.isNaN(Number(metricsTotalRaw))
          ? Number(metricsTotalRaw)
          : null;
      return {
        ...state,
        data: nextData,
        getStats,
        metricsTotal,
        params: payload?.params ?? null,
        loaded: true,
        loading: false,
      };
    }
    case RESET_DASHBOARD_CACHE:
      return {
        ...state,
        loaded: false,
        params: null,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
